import AssistantControlPanel from './AssistantControlPanel';
export default AssistantControlPanel;
